import React, { useState, useRef, useEffect, useId } from 'react'
import { AppContent, AppSidebar, AppFooter, AppHeader } from '../components/index'
const IDLE_TIME = 1800000 // 300000 // 5 minutes
const DefaultLayout = () => {
  
 const [isIdle, setIsIdle] = useState(false)
  const timerRef = useRef(null)
 const resetTimer = () => {
    setIsIdle(false)

    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }

    timerRef.current = setTimeout(() => {
      setIsIdle(true)
    }, IDLE_TIME)
  }

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'scroll', 'click']

    events.forEach((event) => window.addEventListener(event, resetTimer))

    resetTimer() // start timer

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
      events.forEach((event) => window.removeEventListener(event, resetTimer))
    }
  }, [])
useEffect(() => {
    if (isIdle) {
      // alert('Session expired')
       localStorage.removeItem("docentry");
            localStorage.removeItem("user");
            localStorage.removeItem("email");
            localStorage.removeItem("empid");
      window.location = '/'
    }
  }, [isIdle])

  return (
    <div>
      <AppSidebar />
      <div className="wrapper d-flex flex-column min-vh-100 bg-light dark:bg-transparent">
        <AppHeader />
        <div className="body flex-grow-1 px-3">
          <AppContent />
        </div>
        <AppFooter />
      </div>
    </div>
  )
}

export default DefaultLayout
